import * as React from 'react'
import { SVGProps } from 'react'
const SvgSquareDivide: React.FC<React.SVGProps<SVGSVGElement>> = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    stroke="currentColor"
    strokeWidth={1.5}
    strokeLinecap="round"
    strokeLinejoin="round"
    className="square-divide_svg__lucide square-divide_svg__lucide-square-divide-icon square-divide_svg__lucide-square-divide"
    {...props}>
    <rect width={18} height={18} x={3} y={3} rx={2} ry={2} />
    <path d="M8 12h8M12 16h0M12 8h0" />
  </svg>
)
export default SvgSquareDivide
